"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author siranush.avetisyan
 * @author Vahagn Lazyan
 * @since 7/14/17.
 */
var DePermission = /** @class */ (function () {
    function DePermission(_canCreate, _canDelete, viewPermissionDto, editPermissionDto, addPermissionDto) {
        this._canCreate = _canCreate;
        this._canDelete = _canDelete;
        this._viewPermissionDto = viewPermissionDto || {};
        this._editPermissionDto = editPermissionDto || {};
        this._addPermissionDto = addPermissionDto || {};
    }
    Object.defineProperty(DePermission.prototype, "canView", {
        get: function () {
            return this._viewPermissionDto.permission;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DePermission.prototype, "canEdit", {
        get: function () {
            return this._editPermissionDto.permission;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DePermission.prototype, "canCreate", {
        get: function () {
            return this._canCreate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DePermission.prototype, "canDelete", {
        get: function () {
            return this._canDelete;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DePermission.prototype, "viewableFields", {
        get: function () {
            return this._viewPermissionDto.fields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DePermission.prototype, "editableFields", {
        get: function () {
            return this._editPermissionDto.fields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DePermission.prototype, "addableFields", {
        get: function () {
            return this._addPermissionDto.fields;
        },
        enumerable: true,
        configurable: true
    });
    return DePermission;
}());
exports.DePermission = DePermission;
//# sourceMappingURL=de-permission.model.js.map